import React from 'react'
import SarasTrans from '../../../../library/notifications/SarasTrans'
import * as fn from "../../../../helper/uiFunctions";
import SarasTooltip from '../../../../library/notifications/SarasTooltip';

const DocStatus = (props) => {
    const { formObject, viewData } = props;

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");

    const rsStatusHidden = formObject.getValueFromKey(viewData, "dataList.rsStatusHidden", "1");
    const rsStatusVal = formObject.getValueFromKey(viewData, "dataList.rsStatusVal", "");
    const rsReviewerName = formObject.getValueFromKey(viewData, "dataList.rsReviewerName", "");
    const rsStatusClass = formObject.getValueFromKey(viewData, "dataList.rsStatusClass", "");

    const fStatusHidden = formObject.getValueFromKey(viewData, "dataList.fStatusHidden", "1");
    const fStatusVal = formObject.getValueFromKey(viewData, "dataList.fStatusVal", "");
    const fStatusStyle = JSON.parse(formObject.getValueFromKey(viewData, "dataList.fStatusStyle", "{}"));

    const dStatusHidden = formObject.getValueFromKey(viewData, "dataList.dStatusHidden", "1");
    const dStatusVal = formObject.getValueFromKey(viewData, "dataList.dStatusVal", "");
    const dStatusStyle = JSON.parse(formObject.getValueFromKey(viewData, "dataList.dStatusStyle", "{}"));

    const renderRsStatus = () => {
        if (fn.compareNumber(rsStatusHidden, 0)){
            return (
                <SarasTooltip title={<><SarasTrans value='Review' />: <SarasTrans value={rsStatusVal} />{rsReviewerName ? ' by ' : ''}{rsReviewerName}</>}>
                    <span className={`uiChip uiStatusCompactReview${rsStatusClass}`} ><SarasTrans value={rsStatusVal} />{rsReviewerName ? ' by ' : ''}{rsReviewerName}</span>
                </SarasTooltip>
            )
        }
        else{
            return null
        }
    }

    const renderDsStatus = () => {
        if (fn.compareNumber(dStatusHidden, 0)){
            return (
                <SarasTooltip title={<><SarasTrans value='Document Status' />: <SarasTrans value={dStatusVal} /></>}>
                    <span className="uiChip" style={dStatusStyle}><SarasTrans value={dStatusVal} /></span>
                </SarasTooltip>
            )
        }
        else{
            return null
        }
    }

    const renderFsStatus = () => {
        if (fn.compareNumber(fStatusHidden, 0)){
            return (
                <SarasTooltip title={<><SarasTrans value='Finance Status' />: <SarasTrans value={fStatusVal} /></>}>
                    <span className="uiChip" style={fStatusStyle}><SarasTrans value={fStatusVal} /></span>
                </SarasTooltip>
            )
        }
        else{
            return null
        }
    }

    return (
        <div className="saras-cell">
            <div className={`${valCssClass} uiDocStatus`}>
                <div>
                    {renderRsStatus()}
                </div>
                <div>
                    {renderDsStatus()}
                </div>
                <div>
                    {renderFsStatus()}
                </div>
            </div>
        </div>
    )
}

export default DocStatus;
